const locale = {
  ATTENTION: 'Attention',
  PATIENTS: 'Patients',
  CALENDAR: 'Calendrier',
  PHARMACIES: 'Pharmacies',
  ORDERS: 'Ordres',
  MANAGED_REPEATS: 'Répétitions Gérées',
  SERVICES: 'Services',
  BANNERS: 'Bannières',
  ONLINESHOP: 'Magasin en Ligne',
  REVIEWS: 'Commentaires',
  DASHBOARD: 'Tableau de Bord',
  ANNOUNCEMENTS: 'Quoi de neuf',
  RESOURCES: 'Ressources',
  BROADCAST: 'Diffuser',
  PHARMACY_DETAILS: 'Détails de la pharmacie',
  BROADCASTING: 'Broadcasting',
  MASTER_SERVICES: 'Services maîtres',
  QUESTIONNAIRES: 'Questionnaires',
  CAMPAIGNS: 'Campagnes',
  SMS_CAMPAIGNS: 'Campagnes SMS',
  MARKETING_MATERIAL: 'Matériel marketing',
  MTI_UPLOADER: 'Invitations de patients',
  TRAINING_AND_GUIDES: 'Formation et guides',
  IN_APP_BANNERS: 'Bannières in-app',
  USERS: 'Utilisateurs',
  WEBSITE: 'Créateur de site Web',
};

export default locale;
